import AboutYouTemplate from "YConnect/Configs/Templates/AboutYou.template"

export default {
    "template": AboutYouTemplate.map((field) => ({...field, disabled: true}))
}